/*
 * Module for a list of topics
 */

define([
  "backbone",
  "jquery",
  "marionette",
  "messaging/messenger",
  "./kbRoleListView",
  "modules/shared/sortableList/sortableListModule",
], function (Backbone, $, Marionette, Messenger, KbRoleListView, SortableListModule) {
  "use strict";

  return Marionette.Controller.extend({
    initialize: function (options) {
      this.name = "kbRoleList";
      this.region = options.region;
      this.tenant = options.model;
      this.namespace = options.namespace;
      this._setUpVents();
    },
    show: function () {
      const tenantId = this.tenant.get("tenantId");
      this.kbRoles = Messenger.reqres.request("tenant:kbRoles", tenantId);
      this.tenantKbs = Messenger.reqres.request("tenant:kbs", tenantId);

      Messenger.onSave(function () {
        Messenger.saveAttempted(true);
      }, this);

      const headers = Messenger.reqres.request("kbRole:list:headers");

      const extendedEvents = {
        "click .deleteKbRole": function () {
          const model = this.model;
          Messenger.yesNoDialog(
            $.t("admin.kbRoleAdmin.confirmDeleteKbRole", { name: model.get("name") }),
            {
              yes: function () {
                Messenger.vent.trigger("track:interaction", {
                  action: "Delete KB Role",
                  id: model.id,
                  idType: "KB Role",
                  object: "KB Role",
                  source: "KB Roles List",
                });
                model.deleteModel();
              },
            },
            this,
          );
        },
      };

      this.layout = new KbRoleListView.kbRoleListLayout();
      this.kbRolesList = this.addSubModule(
        new SortableListModule({
          region: this.layout.kbRoles,
          headers: headers,
          recordsPerPage: SortableListModule.DEFAULT_RECORDS_PER_PAGE,
          namespace: this.namespace,
          extendedEvents: extendedEvents,
        }),
      );

      this.layout.on("add:kbRole", this.onAddRole, this);
      this.layout.on(
        "show",
        function () {
          this._showSubViews();
        },
        this,
      );
      this.showRegion(this.layout);
    },
    onAddRole: function () {
      const tenantId = this.tenant.get("tenantId");
      if (!this.tenantKbs) {
        this.tenantKbs = Messenger.reqres.request("tenant:kbs", tenantId);
        if (!this.tenantKbs) {
          Messenger.okDialog("admin.kbRoleAdmin.errorNoKb");
          return;
        }
      }
      this.tenantKbs.onSynced(function () {
        if (this.tenantKbs.length === 0) {
          Messenger.okDialog("admin.kbRoleAdmin.errorNoKb");
          return;
        }
        if (!this.kbRoles) {
          this.kbRoles = Messenger.reqres.request("tenant:kbRoles", tenantId);
        }
        this.kbRoles.onSynced(function () {
          const kbRole = this.kbRoles.addNewKbRole();
          kbRole.set("tenantId", this.tenant.get("tenantId"));
          Messenger.vent.trigger("show:tenant:profile:role", { role: kbRole });
        }, this);
      }, this);
    },
    onShowRoles: function () {
      this.show();
      Backbone.history.navigate("accountAdmin/tenants/" + this.tenant.id + "/roles");
    },
    _showSubViews: function () {
      this.kbRoles.onSynced(function () {
        this.kbRolesList.show(this.kbRoles);
      }, this);
    },
    _setUpVents: function () {
      Messenger.vent.on("show:tenant:profile:roles", this.onShowRoles, this);
    },
  });
});
